import * as React from 'react';
import { UIHeading3 } from '@cian/ui-kit';

import { IPromoBanner } from '../../../types/newbuildingBanners/promoBanner';
import { TBannerTheme } from '../utils/bannerTypeToTheme';
import { Banner } from '../Banner/Banner';

import * as styles from './NewbuildingBrokerBanner.css';

interface INewbuildingBrokerBannerProps extends IPromoBanner {
  theme: TBannerTheme;
  button: React.ReactNode;
}

export const NewbuildingBrokerBanner = ({ title, theme, button }: INewbuildingBrokerBannerProps) => {
  return (
    <Banner
      theme={theme}
      title=""
      imageUrl={null}
      labels={null}
      subtitle=""
      customClassName={styles['custom-container']}
      customContent={
        <div className={styles['custom-content']}>
          <UIHeading3 color="text-inverted-default" textAlign="center" whiteSpace="pre-line">
            {title}
          </UIHeading3>
        </div>
      }
      footer={
        <div className={styles['footer-button']} onMouseDown={event => event.stopPropagation()}>
          {button}
        </div>
      }
    />
  );
};
